"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatEventKind = exports.SenderRole = void 0;
var SenderRole;
(function (SenderRole) {
    SenderRole["CLIENT"] = "client";
    SenderRole["PROJECT_MANAGER"] = "project_manager";
    SenderRole["SYSTEM"] = "system";
})(SenderRole || (exports.SenderRole = SenderRole = {}));
var ChatEventKind;
(function (ChatEventKind) {
    ChatEventKind["MONEY_RELEASE"] = "money_release";
    ChatEventKind["DRAWDOWN_RELEASED"] = "drawdown_released";
    ChatEventKind["SUB_MILESTONE_RELEASE"] = "sub_milestone_release";
    ChatEventKind["MILESTONE_COMPLETE"] = "milestone_complete";
    ChatEventKind["PROJECT_ACCEPTED"] = "project_accepted";
})(ChatEventKind || (exports.ChatEventKind = ChatEventKind = {}));
